export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'DASHBOARDS': 'Dashboards',
            'MASTERS': 'Masters',
            'SETTINGS': 'Settings',
            'ADMIN': 'Admin',
            'TRANSACTIONS': 'Transactions',
            'REPORTS': 'Reports',
            'INTERNSHIP': 'Internship',
            'ACTIVITY':'Activity',
            'EMPLOYERS':'Employers',
            'STUDENTS':'Students',
            'RESOURCES':'Resources',
            'SAMPLE': {
                'TITLE': 'Sample',
                'BADGE': '25'
            }
        }
    }
};
